import { AppConfig } from "ENV";

const cl = {
  countryCode: 'cl',
  header: {
    topNavbar: {
      socialMedias: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/autofact_/',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/Autofact.cl',
        },
        {
          name: 'twitter',
          href: 'https://twitter.com/Autofactcl',
        },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/c/AutofactChile',
        }
      ],

      links: [
        {
          label: 'Mi cuenta',
          href: '/login',
          icon: 'my_account',
        },
        {
          label: 'Regístrate',
          href: '/registro',
          icon: 'register',
        },
        {
          label: 'Servicio al Cliente',
          href: '/ayuda',
          icon: 'customer_service',
        },
        {
          label: 'Servicio Empresas',
          href: 'https://www.autofactpro.com/cl',
          icon: '',
        },
      ],
    },

    mainNavbar: {
      links: [
        {
          name: 'el informe',
          href: '/informes',
          icon: {
            namespace: 'report',
            name: 'report_standard',
          },
          active: true,
        },
        {
          name: 'precio usados',
          href: '/precio-autos-usados',
          icon: {
            namespace: 'report',
            name: 'report_price',
          },
          active: true,
        },
        {
          name: 'transferencias',
          href: '/transferencias',
          icon: {
            namespace: 'item',
            name: 'diagonal_arrows',
          },
          active: true,
        },
        {
          name: 'blog',
          href: '/blog',
          active: true,
        },
      ],
      reportButton: {
        text: 'Pedir mi Informe',
        href: 'https://compra.autofact.cl/informe-full',
      },
    },
    offCanvas: {
      firstSmallButton: {
        label: 'Ingresar',
        href: '/login',
      },
      secondSmallButton: {
        label: 'Regístrate',
        href: '/registro',
      }
    }
  },
  footer: {
    pageUrl: "https://www.autofact.cl",
    sections: [
      {
        name: 'AUTOFACT',
        links: [
          {
            name: 'Sobre Autofact',
            href: '/sobre-autofact',
          },
          {
            name: 'Conócenos',
            href: '/conocenos',
          },
          {
            name: 'Autofact en la prensa',
            href: '/autofact-en-prensa',
          },
          {
            name: 'Términos y condiciones',
            href: '/terminos-y-condiciones',
          },
          {
            name: 'Política de privacidad',
            href: '/política-de-privacidad',
          },
          {
            name: 'Trabaja con nosotros',
            href: '/trabaja-con-nosotros',
          },
        ]
      },
      {
        name: 'EL INFORME',
        links: [
          {
            name: '¿Qué incluye el informe?',
            href: '/informes',
          },
          {
            name: 'Tipos de informe',
            href: '/compra',
          },
          {
            name: 'Informe ejemplo',
            href: '/informe-ejemplo',
          },
        ]
      },
      {
        name: 'SERVICIOS',
        links: [
          {
            name: 'Informe historial de vehículo',
            href: '/informe-full',
          },
          {
            name: 'Transferencia de vehículo',
            href: '/transferencia-digital',
          },
          {
            name: 'Informe de precio de vehículo',
            href: '/informe-tasacion-comercial',
          },
        ]
      },
      {
        name: 'HERRAMIENTAS',
        links: [
          {
            name: 'Checklist revisión vehículo',
            href: 'https://checklist.autofact.cl/',
          },
          {
            name: 'Rectificación Kilometraje',
            href: '/solicitar-correccion-kilometrajes',
          },
          {
            name: 'Valor permiso de circulación',
            href: '/permiso-de-circulacion',
          },
          {
            name: 'Valores comerciales de vehículos',
            href: '/valor-comercial-autos',
          },
        ]
      },
      {
        name: 'SÍGUENOS',
        links: [
          {
            namespace: 'social',
            icon: 'instagram',
            href: 'https://www.instagram.com/autofact_/',
          },
          {
            namespace: 'social',
            icon: 'facebook',
            href: 'https://www.facebook.com/Autofact.cl',
          },
          {
            namespace: 'social',
            icon: 'twitter',
            href: 'https://twitter.com/Autofactcl',
          },
          {
            namespace: 'social',
            icon: 'youtube',
            href: 'https://www.youtube.com/c/AutofactChile',
          }
        ]
      }
    ]

  }
  ,
  body: {
    arancelPrice: AppConfig.arancel,
  },
}

export default cl;
